import { ca } from '@cian/analytics';

export const MORTGAGE_BANNER_TRAP_TYPE = 'listing_suburban_build_house';
export const MORTGAGE_BANNER_DISPLAY_NAME = 'Ипотека на строительство домов';

const getMortgageBannerPageExtra = () => ({
  trap_type: MORTGAGE_BANNER_TRAP_TYPE,
  bannerName: MORTGAGE_BANNER_DISPLAY_NAME,
  trapid: MORTGAGE_BANNER_DISPLAY_NAME,
});

const getMortgageBannerEventBase = () => ({
  name: 'oldevent' as const,
  category: 'trap',
  label: 'mortgage_banner',
  page: {
    extra: getMortgageBannerPageExtra(),
  },
});

export const trackMortgageBannerClick = () => {
  ca('eventSite', {
    ...getMortgageBannerEventBase(),
    action: 'click_sopr',
  });
};

let hasMortgageBannerShowBeenSent = false;

export const trackMortgageBannerShow = () => {
  if (hasMortgageBannerShowBeenSent) {
    return;
  }
  hasMortgageBannerShowBeenSent = true;
  ca('eventSite', {
    ...getMortgageBannerEventBase(),
    action: 'show_sopr',
  });
};
